import { MapUtils } from '../../../../utility/map-utils.js';
import { cloneData, isSameData } from '../../../dto/data-model-utils.js';
import {
  SerializedData, SerializationContext, DataModelBuilder,
} from '../../../dto/data-model.js';
import { OnlineProductOrder } from '../../online-product-order.js';
import { AuditLogEntryType } from '../audit-log-entry-type.js';
import { AuditLogEntry } from '../audit-log-entry.js';

export class OnlineProductOrderCreatedEntry extends AuditLogEntry {
  static readonly TYPE_ID: string = '7fa85879e8c6428bb5821626c076b299';

  private constructor(
    public readonly order: OnlineProductOrder,
  ) {
    super();
  }

  get $typeId(): string {
    return OnlineProductOrderCreatedEntry.TYPE_ID;
  }

  get type(): AuditLogEntryType {
    return AuditLogEntryType.OnlineProductOrderCreated;
  }

  generateQueryData(): SerializedData {
    return {
      businessRef: this.order.businessRef.encode(),
      orderId: this.order.uniqueId,
      customerId: this.order.creatorId,
      isGuestOrder: this.order.isGuestOrder,
    };
  }

  static create(args: {
    order: OnlineProductOrder,
  }): OnlineProductOrderCreatedEntry {
    return new OnlineProductOrderCreatedEntry(
        args.order,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): OnlineProductOrderCreatedEntry {
    return this.create({
      order: context.fromData<OnlineProductOrder>(MapUtils.getRecord(map, 'order')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      order: context.toData(this.order),
    };
  }

  clone(): this {
    return OnlineProductOrderCreatedEntry.create({
      order: cloneData(this.order),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.order, this.order);
  }
}

export class OnlineProductOrderCreatedEntryBuilder extends DataModelBuilder<OnlineProductOrderCreatedEntry> {
  build(context: SerializationContext, map: SerializedData): OnlineProductOrderCreatedEntry {
    return OnlineProductOrderCreatedEntry.fromMap(context, map);
  }
}
